import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different feedback action types
*/
let initialstate = { forms: [], patientforms: [] }
export default function surgeon_operation(state = { ...initialstate }, action) {
  switch (action.type) {
    case ActionType.FEEDBACK_FORMS:
      return { ...state, forms: action.forms }
    case ActionType.FEEDBACK_GRAPH:
      return { ...state, oks: action.oks, pain: action.pain, rom: action.rom }
    case ActionType.FEEDBACK_ERROR:
      return { error: action.hasError, message: action.message }
    case ActionType.FEEDBACK_EDIT:
      return { ...state, patientforms: [...action.forms] }
    case ActionType.ADD_FEEDBACK_FORM:
      return { ...state, patientforms: [...(state.patientforms || []), action.form] }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
